import { render, staticRenderFns } from "./biansuohaoshuju.vue?vue&type=template&id=d0bc80aa&scoped=true&"
import script from "./biansuohaoshuju.vue?vue&type=script&lang=js&"
export * from "./biansuohaoshuju.vue?vue&type=script&lang=js&"
import style0 from "./biansuohaoshuju.vue?vue&type=style&index=0&id=d0bc80aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bc80aa",
  null
  
)

export default component.exports